var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart2 = function SvgHeart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 114
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M66.274 113.837V14.399a36.2 36.2 0 0 0-10.74-9.077A37.2 37.2 0 0 0 41.313.85a37.4 37.4 0 0 0-14.87 1.452A36.8 36.8 0 0 0 13.42 9.435a35.6 35.6 0 0 0-8.988 11.614A34.7 34.7 0 0 0 .987 35.195a34.6 34.6 0 0 0 2.675 14.303 35.4 35.4 0 0 0 8.348 12.058z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M66.274 113.837V14.398a36.2 36.2 0 0 1 10.74-9.076A37.2 37.2 0 0 1 91.235.85a37.4 37.4 0 0 1 14.87 1.452 36.8 36.8 0 0 1 13.023 7.132 35.6 35.6 0 0 1 8.988 11.614 34.7 34.7 0 0 1 3.446 14.146 34.6 34.6 0 0 1-2.675 14.303 35.45 35.45 0 0 1-8.348 12.058z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.445 52.78a5.5 5.5 0 0 0 7.779 0l7.778-7.778c6.443-6.444 6.443-16.891 0-23.335-6.444-6.443-16.891-6.443-23.335 0-6.443 6.444-6.443 16.891 0 23.335z",
    "data-id": "inner"
  })));
};
export default SvgHeart2;